module.exports = __webpack_public_path__ + "static/media/hogar_no_inflamable.40809bb2.svg";